exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mySubHeading {\n  font-size: 16px;\n  font-weight: 300;\n  font-style: italic; }\n\n.myBody {\n  font-size: 16px;\n  font-weight: normal; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Source/Ecim/Ecim.Web/src/app/components/review-application/review-application.component.scss
// module id = ../../../../../src/app/components/review-application/review-application.component.scss
// module chunks = main